import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSlidesTall"><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 2C5.11929 2 4 3.11929 4 4.5V15.5C4 16.8807 5.11929 18 6.5 18H8V19.5C8 20.8807 9.11929 22 10.5 22H17.5C18.8807 22 20 20.8807 20 19.5V8.5C20 7.11929 18.8807 6 17.5 6H16V4.5C16 3.11929 14.8807 2 13.5 2H6.5ZM10.5 6H15V4.5C15 3.67157 14.3284 3 13.5 3H6.5C5.67157 3 5 3.67157 5 4.5V15.5C5 16.3284 5.67157 17 6.5 17H8V8.5C8 7.11929 9.11929 6 10.5 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesTall;
